import { render, staticRenderFns } from "./NextRaces.vue?vue&type=template&id=b3afccec&"
import script from "./NextRaces.vue?vue&type=script&lang=js&"
export * from "./NextRaces.vue?vue&type=script&lang=js&"
import style0 from "./NextRaces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NextRaces.vue"
export default component.exports